export const parseDate = ({ dateString, format }) => {
  if (dateString === null || dateString === undefined || dateString === "") {
    return null;
  }
  const date = new Date(dateString);
  return date;
};
